import styles from './hero.module.scss';
import React from 'react';
import {SimpleSlider} from '../slider.tsx';
import {classNames} from '../../support/classnames.ts';

interface OwnProps {
    url?: string | null;
    urls?: (string | null | undefined)[] | null;
    wide?: boolean;
    hasSelect?: boolean;
    children?: React.ReactNode;
}

export function Hero({children, url, urls, wide, hasSelect}: OwnProps) {
    return (
        <header
            className={classNames(styles.hero, {
                [styles.hero_slider]: urls?.length !== 0,
                [styles.hero_has_select]: hasSelect,
            })}
        >
            <div className={styles.hero__image__wrapper}>
                {typeof urls === 'object' && urls?.length ? (
                    <SimpleSlider
                        className={classNames('hero-slider', {
                            ['hero-slider-empty']: children === undefined,
                        })}
                    >
                        {urls
                            .filter((url) => url !== null)
                            .map((url, key) => (
                                <img key={key} src={url ?? ''} alt={'Hero image'} />
                            ))}
                    </SimpleSlider>
                ) : (
                    <img
                        src={url ?? ''}
                        alt={'Hero image'}
                        className={styles.hero__image}
                        onError={(e) => (e.currentTarget.style.display = 'none')}
                    />
                )}
            </div>

            <div
                className={classNames(styles.hero__content, {
                    [styles.hero__content_wide]: wide,
                })}
            >
                {children}
            </div>
        </header>
    );
}
